import { useTheme } from "next-themes";

export function useDarkModeSSR() {
	const { theme: mode, setTheme } = useTheme();
	const isDarkMode = mode === "dark";

	return {
		isDarkMode,
		mode,
		toggle: () => {
			setTheme(isDarkMode ? "light" : "dark");
		},
		enable: () => {
			setTheme("light");
		},
		disable: () => {
			setTheme("dark");
		},
		set: (value: "dark" | "light") => {
			setTheme(value);
		},
	};
}
